import { PrintedByUserWithType } from "../types/Order"

const getReprintStatusOrders = (printedByUsersWithType: PrintedByUserWithType[], userId: string, orderLastChanged: string) => {
  const printAction = printedByUsersWithType?.find(print => 
    print.actions?.some(action => action.type === "IncomingOrders" && print.userId === userId)
  )?.actions?.find(action => action.type === "IncomingOrders")

  if (orderLastChanged && 
    ((printAction && printAction.printedDateTime < orderLastChanged))) {
    return true
  } else {
    return false
  }
}

export default getReprintStatusOrders